import { render } from "./NavbarProjectName.vue?vue&type=template&id=f05e8f06&scoped=true"
import script from "./NavbarProjectName.vue?vue&type=script&lang=js"
export * from "./NavbarProjectName.vue?vue&type=script&lang=js"

import "./NavbarProjectName.vue?vue&type=style&index=0&id=f05e8f06&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f05e8f06"]])

export default __exports__